import { render, staticRenderFns } from "./ibox.vue?vue&type=template&id=0f151500&"
import script from "./ibox.vue?vue&type=script&lang=js&"
export * from "./ibox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploy/cp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f151500')) {
      api.createRecord('0f151500', component.options)
    } else {
      api.reload('0f151500', component.options)
    }
    module.hot.accept("./ibox.vue?vue&type=template&id=0f151500&", function () {
      api.rerender('0f151500', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/packs/components/widgets/ibox.vue"
export default component.exports